namespace GeniuzPOS.ReportMasterData {
    export interface Report_1504_NForm {
        Year: Serenity.LookupEditor;
        PluCode: Serenity.StringEditor;
        PluDesc: Serenity.StringEditor;
        PluShortDesc: Serenity.StringEditor;
        CatCode: Serenity.StringEditor;
        CatName: Serenity.StringEditor;
        SubCat1Code: Serenity.StringEditor;
        SubCat1Name: Serenity.StringEditor;
        SubCat2Code: Serenity.StringEditor;
        SubCat2Name: Serenity.StringEditor;
        BrandCode: Serenity.StringEditor;
        BrandName: Serenity.StringEditor;
        StyleId: Serenity.StringEditor;
        StyleName: Serenity.StringEditor;
        ColorId: Serenity.StringEditor;
        ColorName: Serenity.StringEditor;
        SizeId: Serenity.StringEditor;
        SizeName: Serenity.StringEditor;
        TasteId: Serenity.StringEditor;
        TasteName: Serenity.StringEditor;
        MatTypeId: Serenity.StringEditor;
        MatTypeName: Serenity.StringEditor;
        SupplId: Serenity.StringEditor;
        SupplName: Serenity.StringEditor;
    }

    export class Report_1504_NForm extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1504_N';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1504_NForm.init)  {
                Report_1504_NForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;

                Q.initFormType(Report_1504_NForm, [
                    'Year', w0,
                    'PluCode', w1,
                    'PluDesc', w1,
                    'PluShortDesc', w1,
                    'CatCode', w1,
                    'CatName', w1,
                    'SubCat1Code', w1,
                    'SubCat1Name', w1,
                    'SubCat2Code', w1,
                    'SubCat2Name', w1,
                    'BrandCode', w1,
                    'BrandName', w1,
                    'StyleId', w1,
                    'StyleName', w1,
                    'ColorId', w1,
                    'ColorName', w1,
                    'SizeId', w1,
                    'SizeName', w1,
                    'TasteId', w1,
                    'TasteName', w1,
                    'MatTypeId', w1,
                    'MatTypeName', w1,
                    'SupplId', w1,
                    'SupplName', w1
                ]);
            }
        }
    }
}
